import type { CSSProperties } from 'react'

// "Sign in with Apple" button conforming to Apple's Human Interface Guidelines — the WHITE variant with a
// black outline: white background, black Apple logo + text, the system font (SF Pro on Apple devices), and
// a corner radius within Apple's allowed 0–50%-of-height range (a pill here). The flow routes through
// Cognito, so this is the visual only and keeps our own onClick.
//
// `label` MUST be one of Apple's official localized strings — e.g. "Continue with Apple",
// "Continuar com a Apple" (pt-BR), "Mit Apple fortfahren" (de) — never a custom phrase.
export function AppleSignInButton({
  onClick,
  disabled,
  label,
  style,
}: {
  onClick: () => void
  disabled?: boolean
  label: string
  style?: CSSProperties
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="flex w-full items-center justify-center gap-2 disabled:opacity-50"
      style={{
        height: '3rem',
        borderRadius: '999px',
        background: '#ffffff',
        color: '#000000',
        border: '1px solid #000000',
        fontFamily: '-apple-system, system-ui, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
        fontSize: '15px',
        fontWeight: 500,
        ...style,
      }}>
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="#000000">
        <path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.71-1.517 0-1.9-.88-3.63-.88-1.698 0-2.302.91-3.67.91-1.377 0-2.332-1.26-3.428-2.8-1.287-1.82-2.323-4.63-2.323-7.28 0-4.28 2.797-6.55 5.552-6.55 1.448 0 2.675.95 3.6.95.865 0 2.222-1.01 3.902-1.01.613 0 2.886.06 4.374 2.19-.13.09-2.383 1.37-2.383 4.19 0 3.26 2.854 4.42 2.955 4.45z" />
      </svg>
      {label}
    </button>
  )
}
